import { ProductTransition } from "@/api/models/product-transition/productTransition.model";
import { productTransitionProcessInitialState } from "./productTransitionProcess";
import { PRODUCT_TRANSITION_PROCESS_CLEAR_STATE } from "./constants";

const clear = (state: any) => {
	Object.assign(state, productTransitionProcessInitialState());
};

const setProductTransition = (state: any, productTransition: ProductTransition) => {
	state.productTransition = productTransition;
};

const setProductTransitionShoppingCartId = (state: any, shoppingCartId: string) => {
	state.shoppingCartId = shoppingCartId;
};

const setProductTransitionStatus = (state: any, status: string) => {
	state.status = status;
};

export default {
	[PRODUCT_TRANSITION_PROCESS_CLEAR_STATE]: clear,
	setProductTransition,
	setProductTransitionShoppingCartId,
	setProductTransitionStatus
};
